/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FollowingCompaniesResponseAllOf,
    FollowingCompaniesResponseAllOfFromJSON,
    FollowingCompaniesResponseAllOfFromJSONTyped,
    FollowingCompaniesResponseAllOfToJSON,
} from './FollowingCompaniesResponseAllOf';
import {
    FollowingCompaniesResponseAllOfData,
    FollowingCompaniesResponseAllOfDataFromJSON,
    FollowingCompaniesResponseAllOfDataFromJSONTyped,
    FollowingCompaniesResponseAllOfDataToJSON,
} from './FollowingCompaniesResponseAllOfData';
import {
    MediaUserApiResponse,
    MediaUserApiResponseFromJSON,
    MediaUserApiResponseFromJSONTyped,
    MediaUserApiResponseToJSON,
} from './MediaUserApiResponse';

/**
 * 
 * @export
 * @interface FollowingCompaniesResponse
 */
export interface FollowingCompaniesResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof FollowingCompaniesResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof FollowingCompaniesResponse
     */
    message: string;
    /**
     * 
     * @type {FollowingCompaniesResponseAllOfData}
     * @memberof FollowingCompaniesResponse
     */
    data: FollowingCompaniesResponseAllOfData;
}

export function FollowingCompaniesResponseFromJSON(json: any): FollowingCompaniesResponse {
    return FollowingCompaniesResponseFromJSONTyped(json, false);
}

export function FollowingCompaniesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FollowingCompaniesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': FollowingCompaniesResponseAllOfDataFromJSON(json['data']),
    };
}

export function FollowingCompaniesResponseToJSON(value?: FollowingCompaniesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': FollowingCompaniesResponseAllOfDataToJSON(value.data),
    };
}

